import cx from 'clsx';

import styles from 'theme/features/dashboard/export/export-dashboard-card.module.scss';

const ExportDashboardCard = ({ children, title, withContentPadding = false }) => (
  <section>
    <header className={styles.title}>{title}</header>
    <div className={cx(withContentPadding && styles.content)}>{children}</div>
  </section>
);

export default ExportDashboardCard;
